import { AUTH_SERVICE_URL } from '../config';

/**
 * Utility function to get the correct avatar URL
 * @param {string} avatar - The avatar path or URL
 * @returns {string} - The complete avatar URL or empty string
 */
export const getAvatarSrc = (avatar) => {
  if (!avatar) {
    return '';
  }
  
  // If it's already a full URL (starts with http), return as is
  if (avatar.startsWith('http')) {
    return avatar;
  }
  
  // If it's a relative path, prepend the auth service URL
  return `${AUTH_SERVICE_URL}${avatar}`;
};

/**
 * Utility function to get avatar source with fallback for user objects
 * @param {Object} user - User object that might have avatar in different properties
 * @returns {string} - The complete avatar URL or empty string
 */
export const getUserAvatarSrc = (user) => {
  if (!user) {
    return '';
  }
  
  // Check different possible avatar properties
  const avatar = user.avatar || user.userMeta?.avatar || user.profile?.avatar;
  
  return getAvatarSrc(avatar);
};
